import React, { useEffect, useState } from "react";
import Layout from "../../components/yenimahalle/Layout";
import BasicHeader from "../../components/yenimahalle/BasicHeader";
import PortalApi from "api/PortalApi";
import styled from "styled-components";
import tw from "twin.macro";
import { EventList, GetEventDetailResponse, OtherEvent } from "models/Response/Portal";
import { useNavigate, useParams } from "react-router-dom";
import NoImageRoutingSidebar from "components/yenimahalle/NoImageRoutingSidebar";
import { slugify } from "utils/slugify";

interface NewsItem {
    id: number;
    title: string;
    date: string;
    description?: string;
    imageSrc?: string;
}

const PageContainer = tw.div`
  pt-8 pb-16 px-4
  flex flex-col lg:flex-row
  justify-between items-start
  max-w-screen-xl mx-auto
  space-y-8 lg:space-y-0 lg:space-x-8
`;
const CARD_MAX_WIDTH = "600px";

const Heading = tw.span`
  inline-block my-4 pl-3 py-1 text-xl font-bold border-l-4 border-primary-500
`;

const LeftColumn = tw.div`w-full lg:w-9/12 flex justify-center`;
const RightColumn = tw.div`w-full lg:w-3/12 mt-8 lg:mt-0`;
const Content = tw.div`max-w-screen-xl mx-auto py-8`;

// Wrapper to give some top padding if needed
const CardWrapper = styled.div`
  ${tw`flex flex-col items-start `}
`;

const HeadingOverlay = styled.span`
  ${tw`text-xl font-bold leading-snug pl-3 py-1 border-l-4 border-primary-500 break-words`}
  display: inline-block;
  max-width: ${CARD_MAX_WIDTH};
  margin-bottom: 1rem;
`;

const Card = styled.div`
  ${tw`
    bg-primary-100 
    rounded-tr-4xl 
    rounded-bl-4xl 
    overflow-hidden 
    p-6
    border
    border-gray-300
  `}
  max-width: ${CARD_MAX_WIDTH};
  width: 100%;
`;
const EventMeta = styled.div`
  ${tw`mb-4 text-sm text-gray-700 leading-snug`}
  span {
    ${tw`block mb-1`}
  }
`;


const HtmlContent = styled.div`
  ${tw`text-sm leading-relaxed text-gray-800`}
  p {
    margin-bottom: 1rem;
  }
  a {
    color: #1d4ed8;
    text-decoration: underline;
  }
`;

const EtkinlikDetay: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const [event, setEvent] = useState<GetEventDetailResponse>();

    const fetchEvent = async () => {
        try {
            const response = await PortalApi.getEventDetail(Number(id));
            if (response) {
                setEvent(response);
            }
        } catch (err) {
            console.error("Etkinlikler alınamadı:", err);
        }
    };

    useEffect(() => {
        fetchEvent();
    }, [id]);

    const handleCardClick = (item: NewsItem & { id: number }) => {
        navigate(`/EtkinlikDetay/${slugify(item.title)}/${item.id}`);
        window.scrollTo({ top: 100, behavior: "smooth" });
    };

    return (
        <Layout>
            <BasicHeader
                headingLine1="Sosyal Belediyecilik Anlayışına Sahip Mutlu Bir İlçe"
                headingLine2=""
            />
            <PageContainer>
            <LeftColumn>
  <CardWrapper>
    <HeadingOverlay>{event?.eventName}</HeadingOverlay>
    <Card>
  <EventMeta>
    <span><strong>Tarih:</strong> {new Date(event?.startDate ?? "").toLocaleDateString("tr-TR")} - {new Date(event?.finishDate ?? "").toLocaleDateString("tr-TR")}</span>
    <span><strong>Yer:</strong> {event?.eventPlace}</span>
  </EventMeta>

  <div dangerouslySetInnerHTML={{ __html: event?.detailContent }} />
</Card>
  </CardWrapper>
</LeftColumn>
                <RightColumn>
                    <Content>
                        <NoImageRoutingSidebar
                            heading="Diğer Etkinlikler"
                            cards={event?.otherEvents.map((item: OtherEvent) => ({
                                id: item.eventId,
                                title: item.eventName,
                            }))}
                            onItemClick={handleCardClick}

                        />
                    </Content>
                </RightColumn>
            </PageContainer>

        </Layout>
    );
};

export default EtkinlikDetay;
